"use client";
import {
  BuildingOffice2Icon,
  EnvelopeIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { motion } from "framer-motion";

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import ContactUsLottie from "../../lottiefiles/contactus.json";
import { useSEO } from "../../hooks/useSEO";

export default function ContactUs(): JSX.Element {
  useSEO({
    title: "Contact Us | Sports Medicine Clinic Anna Nagar",
    description: "Get in touch with our sports medicine specialists in Chennai. Book an appointment or contact us for inquiries regarding your recovery and health.",
    keywords: "contact sports doctor chennai, clinic phone number, orthopedic appointment anna nagar"
  });

  return (
    <main className="relative isolate bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 items-center gap-8">
        <motion.div
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative px-6 pt-24 pb-20 sm:pt-32 lg:static lg:px-8 lg:py-10"
        >
          <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
            <motion.h2
              initial={{ opacity: 0, y: -40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl"
            >
              Get in touch
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
              className="mt-6 text-lg/8 text-gray-600"
            >
              Proin volutpat consequat porttitor cras nullam gravida at.
            </motion.p>

            <motion.dl
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.2, ease: "easeOut", delay: 0.4 }}
              className="mt-10 space-y-4 text-base/7 text-gray-600"
            >
              <div className="flex gap-x-4">
                <dt className="flex-none">
                  <BuildingOffice2Icon
                    aria-hidden="true"
                    className="h-7 w-6 text-gray-400"
                  />
                </dt>
                <dd>
                  480, School Rd, ONGC Housing, Anna Nagar West Extension,
                  <br />
                  Chennai, Tamil Nadu 600101
                </dd>
              </div>
            </motion.dl>
          </div>
        </motion.div>

        {/* animation Section */}
        <div className="px-6 pb-20 lg:px-8 lg:py-10">
          <DotLottieReact
            data={ContactUsLottie}
            loop
            autoplay
            className="w-full h-auto"
          />
        </div>
      </div>

      {/* Map Section */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.5 }}
        className="h-[350px] w-full mt-11"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.0950363677907!2d80.19103157462469!3d13.093155887233463!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52640f2664a9e3%3A0xcfc74899d706588d!2s480%2C%20School%20Rd%2C%20ONGC%20Housing%2C%20Anna%20Nagar%20West%20Extension%2C%20Chennai%2C%20Tamil%20Nadu%20600101!5e0!3m2!1sen!2sin!4v1756705283967!5m2!1sen!2sin"
          className="w-full h-full rounded-lg shadow-lg"
        ></iframe>
      </motion.div>
    </main>
  );
}
